"use strict";

angular.module("portal.lookup").controller("UserLookup", [
    "$scope",
    "$state",
    "$stateParams",
    "$rootScope",
    "Complaints",
    "Enterprise",
    "EnterprisePublicLookup",
    "LicenseRequests",
    "Services",
    "Users",
    function(
        $scope,
        $state,
        $stateParams,
        $rootScope,
        Complaints,
        Enterprise,
        EnterprisePublicLookup,
        LicenseRequests,
        Services,
        Users
    ) {
        $scope.loading = true;
        $scope.looking_up = false;
        $scope.promises = [];
        $scope.parameters = {
            enterpriseID: $rootScope.enterpriseID
        };
        $scope.license_label = "License";
        $scope.show_search_results = false;
        $scope.filters = [];
        $scope.search_columns = [];
        $scope.search_header_columns = [];
        $scope.users = [];
        $scope.reverse = false;

        $scope.currentPage;
        $scope.numPerPage = 10;
        $scope.perPages = [
            { id: 10, name: 10 },
            { id: 15, name: 15 },
            { id: 20, name: 20 },
            { id: 25, name: 25 },
            { id: 50, name: 50 }
        ];
        $scope.record_count = 0;
        $scope.filterFound = false;
        $scope.messages = ["Please enter a value into one of the filter fields to search."];

        //recaptcha vars
        $scope.recaptchaMessage = $scope.enterprise.recaptcha_site_key_v3 != null ? "" : "There was an issue loading recaptcha, please try again or contact system administrator."; //message to display

        if (!$stateParams.lookup_object) {
            $scope.lookup_object = {
                enterprise_id: $rootScope.enterpriseID,
                records_offset: 0,
                records_total: 10,
                sort_fields: null,
                from_search: true,
                recaptcha_passed: $scope.enterprise.recaptcha_enabled ? false : true, //to gatekeep intended function, make true if recaptcha is off, if passed from the base lookup page, will have already checked recaptcha
            };
        } else {
            $scope.lookup_object = $stateParams.lookup_object; // this will contain data like first_name, etc. from base lookup
            $scope.lookup_object.enterprise_id = $rootScope.enterpriseID;
            if (!$scope.lookup_object.records_offset)
                $scope.lookup_object.records_offset = 0;
            if (!$scope.lookup_object.records_total)
                $scope.lookup_object.records_total = 10;
            if (!$scope.lookup_object.sort_fields)
                $scope.lookup_object.sort_fields = null;
            if (!$scope.lookup_object.sort_fields)
                $scope.lookup_object.sort_direciton = " asc";

            getCount(search); // state params are not null, first time around, need to get count
        }

        $scope.currentState = $state.current.name;
        if ($stateParams.priorState) {
            $scope.priorState = $stateParams.priorState;
        }

        // Make sure we have the enterprise details
        if ($rootScope.enterprise != null) {
            $scope.enterprise = $rootScope.enterprise;
            $scope.loading = false;
        } else {
            if ($rootScope.userAccount !== null) {
                Enterprise.get($scope.parameters).then(function(result) {
                    $scope.enterprise = result;
                    $scope.loading = false;
                });
            } else {
                Enterprise.getLess($scope.parameters).then(function(result) {
                    $scope.enterprise = result;
                    $scope.loading = false;
                });
            }
        }

        // Get the entity labels
        $scope.userLabel = $scope.enterprise.userLabels["USER"];
        $scope.serviceLabel = $scope.enterprise.serviceLabels["SERVICE"];

        // Get the user lookup filters columns
        EnterprisePublicLookup.get({
            enterpriseId: $rootScope.enterpriseID,
            code: "filter",
            entity_type: "user",
        }).then(function(result) {
            if (result != null) {
                result.forEach(function(filter) {
                    if (filter.alias == "application_level_id" || filter.alias == "certification_level_id") {
                        filter.selectShow = "combined_name";
                    } else {
                        filter.selectShow = "name";
                    }
                });
                $scope.filters = result;
                $scope.filtersAlias = [];
                result.forEach(function (filter) {
                    $scope.filtersAlias.push(filter.alias);
                });
                $scope.filterFound = $scope.filtersAlias.some(function (name) {
                    return $scope.lookup_object.hasOwnProperty(name) && $scope.lookup_object[name] && $scope.lookup_object[name] != '';
                });
            }
        });

        // Get the user lookup search columns
        EnterprisePublicLookup.get({
            enterpriseId: $rootScope.enterpriseID,
            code: "search",
            entity_type: "user",
        }).then(function(result) {
            $scope.search_columns = [];
            $scope.search_header_columns = [];
            $scope.investigation_columns = [];
            $scope.certification_columns = [];
            $scope.cert_attribute_columns = [];
            $scope.application_columns = [];
            $scope.user_services_columns = [];

            if (result != null) {
                // we will filter this down further below
                $scope.search_columns = result.map(function (c) {
                    if (c.alias === 'user_id_alert_id') $scope.userAlertsUsed = true;

                    return c;
                });

                $scope.search_header_columns = $scope.search_columns
                    .filter(function(c) {
                        // column may be a header column but not sortable, in that case sort button is removed
                        return c.sortable;
                    })
                    .slice(0, 7); // let's just get the first 7 columns

                $scope.search_columns_singular = $scope.search_columns.filter(
                    function(c) {
                        return c.singular_relationship && !c.sortable;
                    }
                );

                $scope.search_columns_investigations = $scope.search_columns.filter(
                    function(c) {
                        return (
                            !c.singular_relationship &&
                            c.category == "Investigation"
                        );
                    }
                );

                $scope.search_columns_investigations.forEach(function(column) {
                    // create columns for list directive
                    $scope.investigation_columns.push({
                        label: column.label,
                        field: column.alias,
                        type: column.format_type,
                        revertTimeZone: true
                    });
                });

                $scope.search_columns_applications = result.filter(function(c) {
                    return (
                        !c.singular_relationship && c.category == "Application"
                    );
                });

                $scope.search_columns_applications.forEach(function(column) {
                    // create columns for list directive
                    $scope.application_columns.push({
                        label: column.label,
                        field: column.alias,
                        type: column.format_type,
                        revertTimeZone:
                            column.format_type == "date"
                                ? column.field.toLowerCase() == "issue_date" ||
                                  column.field.toLowerCase() ==
                                      "expiration_date"
                                    ? true
                                    : false
                                : undefined
                    });
                });

                $scope.search_columns_certifications = result.filter(function (c) {
                    return (
                        !c.singular_relationship && c.category == "Certification List"
                    );
                });

                $scope.search_columns_certifications.forEach(function (column) {
                    // create columns for list directive
                    $scope.certification_columns.push({
                        label: column.label,
                        field: column.alias,
                        type: column.format_type,
                        revertTimeZone:
                            column.format_type == "date"
                                ? column.field.toLowerCase() == "issue_date" ||
                                    column.field.toLowerCase() ==
                                    "expiration_date" || column.field.toLowerCase() == "initial_issue_date"
                                    ? true
                                    : false
                                : undefined
                    });
                });

                // create columns for list directive
                $scope.cert_attribute_columns.push({
                    label: "Attribute Name",
                    field: "name",
                    type: "string"
                });
                // create columns for list directive
                $scope.cert_attribute_columns.push({
                    label: "Attribute Value",
                    field: "type",
                    type: "string"
                });
                // create columns for list directive
                $scope.cert_attribute_columns.push({
                    label: "Attribute Value",
                    field: "value",
                    type: "string"
                });

                $scope.search_columns_services = result.filter(function(c) {
                    return (
                        !c.singular_relationship &&
                        c.table_name == "user_services"
                    );
                });

                $scope.search_columns_services.forEach(function(c) {
                    $scope.user_services_columns.push({
                        label: c.label,
                        field: c.alias,
                        type: c.format_type,
                        link:
                            c.field == "name"
                                ? {
                                      // conditionally add link property
                                      state: "portal.menus.servicelookupdetail",
                                      params: [
                                          {
                                              name: "id",
                                              field: "id"
                                          },
                                          {
                                              name: "priorState",
                                              field: "priorState"
                                          },
                                          {
                                              name: "lookup_object",
                                              field: "lookup_object"
                                          }
                                      ]
                                  }
                                : undefined,
                        revertTimeZone:
                            c.format_type == "date"
                                ? c.field.toLowerCase() == "issue_date" ||
                                  c.field.toLowerCase() == "expiration_date"
                                    ? true
                                    : false
                                : undefined
                    });
                });
            }
        });

        function toggleUser(user) {
            user.isOpen = !user.isOpen;
            if (user.isOpen) {

                // get user alerts if needed
                // Turns out this can be set to empty in the UsersController when the alert icon isn't selected. I'm not sure if there's another reason for
                // setting it to empty there. So, I'm not going to change that functionality.  I'm just going to change it here, because now we allow them
                // to show the text of the alerts even if that icon field isn't selected.  So, let's just go ahead and check this again.
                if (user.alert_count > 0 && $scope.userAlertsUsed) {
                    Users.getUserAlerts({ userID: user.id, is_public: true }).then(
                        function(result) {
                            user.alerts = result;

                            if (user.alerts != null && user.alerts.length > 0) {
                                user.alerts_concat = "";
                                user.alerts.forEach(function(alert) {
                                    // slightly faster than using .reduce
                                    user.alerts_concat += ", " + alert.message;
                                });
                            }
                        }
                    );
                }

                // grab user grid data
                if (
                    $scope.search_columns_applications.length > 0 &&
                    !user.applications
                ) {
                    user.applications_list_loading = true;
                    LicenseRequests.getByUserID(
                        user.id,
                        false,
                        $rootScope.enterpriseID
                    ).then(function(result) {
                        user.applications = result;
                        user.applications_list_loading = false;
                    });
                }

                if (
                    $scope.search_columns_certifications.length > 0 &&
                    !user.certifications
                ) {
                    user.certifications_list_loading = true;
                    Users.getUserCertifications(
                        user.id,
                        false,
                        $rootScope.enterpriseID
                    ).then(function (result) {
                        user.certifications = result;
                        user.certifications_list_loading = false;
                    });
                }

                if (
                    $scope.search_columns_investigations.length > 0 &&
                    !user.investigations
                ) {
                    user.investigations_list_loading = true;
                    Complaints.getByUserID(
                        user.id,
                        false,
                        $rootScope.enterpriseID
                    ).then(function(result) {
                        user.investigations = result;
                        user.investigations_list_loading = false;
                    });
                }

                if (
                    $scope.search_columns_services.length > 0 &&
                    !user.services
                ) {
                    user.services_list_loading = true;
                    Services.getByUserID(
                        user.id,
                        false,
                        $rootScope.enterpriseID
                    ).then(function(result) {
                        user.services = result.map(function(service) {
                            service.priorState = $state.current.name;
                            service.lookup_object = $scope.lookup_object;
                            return service;
                        });
                        user.services_list_loading = false;
                    });
                }
            }
        }

        $scope.toggleUser = toggleUser;

        function getCount(search) {
            $scope.looking_up = true;
            Users.getUserLookupCount($scope.lookup_object).then(function (
                result
            ) {
                $scope.record_count = result;
                if (search) {
                    search();
                } else {
                    $scope.looking_up = false;
                }
            });
        }

        $scope.getCount = getCount;

        function search() {
            $scope.looking_up = true;
            Users.publicLookupUser($scope.lookup_object).then(function(result) {
                if (result == null) {
                    $scope.looking_up = false;
                    $scope.show_search_results = true;

                    return false;
                }

                $scope.include_suffix = false;
                $scope.include_middle = false;

                $scope.search_columns.forEach(function (s) {
                    if (s.alias == 'suffix') {
                        $scope.include_suffix = true;
                    }
                    if (s.alias == 'middle_name') {
                        $scope.include_middle = true;
                    }
                }); 

                $scope.users = result.map(function(user) {

                    user['header_name'] = user.last_name;
                    if ($scope.include_suffix && user.suffix != '' && user.suffix != null) {
                        user['header_name'] = user['header_name'] + ' ' + user.suffix;
                     }

                    user['header_name'] = user['header_name'] + ', ' + user.first_name;

                    if ($scope.include_middle && user.middle_name != '' && user.middle_name != null) {
                         user['header_name'] = user['header_name'] + ' ' + user.middle_name;
                    }
                  
                    user.isOpen = false;
                    return user;
                });

                $scope.looking_up = false;
                $scope.show_search_results = true;
            });
        }

        $scope.search = search;

        $scope.recaptchaSubmit = function () {
            $scope.looking_up = true;
            if ($scope.enterprise.recaptcha_enabled && $scope.lookup_object.recaptcha_passed != true) {
                if ($scope.enterprise.recaptcha_site_key_v3 != null) {
                    grecaptcha.ready(function () {
                        try {
                            grecaptcha.execute($scope.enterprise.recaptcha_site_key_v3, { action: 'publicUserLookup' }).then(function (token) { //execute returns a token
                                return Enterprise.getRecaptchaResponse("publicUserLookup", token) // send action, token, score to pass over to server for validation, returns a response object
                            }).then(function (response) { // take the response and update variables
                                if (response.success == false) {
                                    $scope.recaptchaMessage = 'Recaptcha Error: ' + response.error;
                                    $scope.looking_up = false;
                                } else {
                                    $scope.recaptchaMessage = "";
                                };
                            }).then(function () {
                                if ($scope.recaptchaMessage == "") {
                                    $scope.getCount(search); //put function here if passed to continue normal "submit" is recaptcha passed
                                } else {
                                    $scope.$apply(); //update dom so error message displays if recaptcha failed
                                };
                            })
                        } catch (error) {
                            $scope.recaptchaMessage = "There was an issue loading recaptcha, please try again or contact system administrator.";
                            $scope.looking_up = false;
                        }
                    });
                } else {
                    return;
                }
            } else {
                $scope.getCount(search); //put function here to continue normal "submit" if recaptcha is turned off
            };
        };


        function clearFilter() {
            $scope.filters.forEach(function(filter) {
                delete $scope.lookup_object[filter.alias];
            });

            $scope.users = [];
            $scope.record_count = 0;
        }

        $scope.clearFilter = clearFilter;

        function sort(column) {
            $scope.reverse = !$scope.reverse;
            $scope.lookup_object.sort_fields = column.alias;
            $scope.lookup_object.sort_direction = $scope.reverse
                ? " asc"
                : "desc";
            $scope.search();
        }

        $scope.sort = sort;

        $scope.determineClasses = function(index, length) {
            var classes = "";

            var value = Math.floor(12 / length);
            var mod = 12 % length;
            if (index < mod) {
                value += 1;
            }
            classes = "col-xs-" + value;

            return classes;
        };

        $scope.setCurrentPage = function(page) {
            $scope.lookup_object.records_offset = page * $scope.numPerPage;
            $scope.search();
            $scope.currentPage = angular.copy($scope.pages[page]);
        };

        $scope.setNumPerPage = function(numPerPage) {
            $scope.numPerPage = numPerPage;
            $scope.lookup_object.records_total = numPerPage;
            $scope.setPages($scope.record_count);
            $scope.search();
        };

        $scope.numOfPages = function(length) {
            return Math.ceil(length / $scope.numPerPage) - 1;
        };

        $scope.setPages = function(length) {
            $scope.pages = [];

            if (length > 0) {
                var i = 0;
                for (i = 0; i <= $scope.numOfPages(length); i++) {
                    $scope.pages.push({ id: i, name: i + 1 });
                }
            } else {
                $scope.pages.push({ id: 0, name: 0 });
            }

            $scope.lookup_object.records_offset = 0;
            $scope.currentPage = angular.copy($scope.pages[0]);
        };

        $scope.$watch("record_count", function(length) {
            $scope.setPages(length);
        });

        // Ensure there is a filter with a value in the lookup
        $scope.$watch("lookup_object", function () {
            if ($scope.filtersAlias && $scope.filtersAlias.length > 0) {
                $scope.filterFound = $scope.filtersAlias.some(function (name) {
                    return $scope.lookup_object.hasOwnProperty(name) && $scope.lookup_object[name] && $scope.lookup_object[name] != '';
                });
            }
        }, true);

        $scope.$watch("enterprise", function () {
            Enterprise.getEnterpriseUserPublicAddresses().then(function (show) {
                if (show) {
                    $scope.userPublicAddresses = true;
                } else {
                    $scope.userPublicAddresses = false;
                }
            });
        });

        $scope.userPublicAddressCheck = function (label) {
            if (label.includes('Public')) {
                return ($scope.userPublicAddresses) ? true : false;
            } else {
                // Not public address, pass
                return true;
            }
        };
    }
]);